import { render, staticRenderFns } from "./ConfiguracionPage.vue?vue&type=template&id=096cd41d&"
import script from "./ConfiguracionPage.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports